import { Box } from '@mui/material';
import React from 'react';
import DetailedAdminReportContainer from '../../containers/DetailedAdminReportContainer';

export default function DetailedAdminReport() {
  return (
    <Box>
      <DetailedAdminReportContainer />
    </Box>
  );
}
